import { render, staticRenderFns } from "./TempCoachAgreement.vue?vue&type=template&id=aed4d6ec&scoped=true&"
import script from "./TempCoachAgreement.vue?vue&type=script&lang=js&"
export * from "./TempCoachAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TempCoachAgreement.vue?vue&type=style&index=0&id=aed4d6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed4d6ec",
  null
  
)

export default component.exports